// 'use client';
// import React from 'react';
// import { BoyIcon, GirlIcon } from './icons';
// import { generateAlternativeGenderUrl } from '@/utils/seo';
// const GenderSelect = ({ formData, hashArray, onChange, isOnChange, ageInMonths = false }) => {
//   const onRadioChange = (event) => {
//     if (event.target && event.target.value !== formData.gender) {
//       let url = generateAlternativeGenderUrl(hashArray);
//       window.location.href = url;
//     }
//   };
//   return (
//     <div className="d-flex justify-content-center w-100 m-auto" style={{ maxWidth: '600px' }}>
//       <div className="d-flex flex-column align-items-center w-100">
//         <label
//           className={`main-checkbox m-auto w-100 ${formData.gender === 'm' ? 'checked' : ''}`}
//           style={{ cursor: 'pointer' }}
//         >
//           <input type="radio" name="gender" value="m" checked={formData.gender === 'm'} onChange={onRadioChange} />{' '}
//           <div className="d-flex align-items-center flex-column box">
//             <div className="d-flex align-items-center">
//               <div className="boy-radio circle-bg circle-bg-green ml-2 ">
//                 <BoyIcon color={formData.gender === 'm' ? '#fff' : '#176c5a'} />
//               </div>
//               <span> {ageInMonths < 240 || ageInMonths === false ? 'Boys' : 'Men'}</span>
//             </div>
//             <div className="bottom-line bottom-line-green" />
//           </div>
//         </label>
//       </div>

//       <div className="d-flex flex-column align-items-center w-100">
//         <label
//           className={`main-checkbox m-auto w-100 ${formData.gender === 'f' ? 'checked' : ''}`}
//           style={{ cursor: 'pointer' }}
//         >
//           <input type="radio" name="gender" value="f" checked={formData.gender === 'f'} onChange={onRadioChange} />{' '}
//           <div className="d-flex align-items-center flex-column box">
//             <div className="d-flex align-items-center">
//               <div className="boy-radio circle-bg circle-bg-green ml-2">
//                 <GirlIcon color={formData.gender === 'f' ? '#fff' : '#176c5a'} />
//               </div>
//               <span>{ageInMonths < 240 || ageInMonths === false ? 'Girl' : 'Women'}</span>
//             </div>
//             <div className="bottom-line bottom-line-green" />
//           </div>
//         </label>
//       </div>
//     </div>
//   );
// };

// export default GenderSelect;

'use client';
import React from 'react';
import { BoyIcon, GirlIcon } from './icons';
import { generateAlternativeGenderUrl } from '@/utils/seo';
const GenderSelect = ({ formData, hashArray, onChange, isOnChange, ageInMonths = false }) => {
  // const onRadioChange = (element) => {
  //   if (element.target && element.target.defaultValue != formData.gender) {
  //     let url = generateAlternativeGenderUrl(hashArray);
  //     window.location.href = url;
  //   }
  // };
  return (
    <div className="d-flex justify-content-center w-100 m-auto" style={{ maxWidth: '600px' }}>
      {/* Male Option */}
      <div className="d-flex flex-column align-items-center w-100">
        <label
          className={`main-checkbox m-auto w-100 ${formData.gender === 'm' ? 'checked' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          <input
            type="radio"
            name="gender"
            value="m"
            checked={formData.gender === 'm'}
            onChange={onChange}
            // className="d-none" // hide visually if needed
          />
          <a
            href={generateAlternativeGenderUrl(hashArray)}
            style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            onClick={(e) => {
              if (!isOnChange && formData.gender !== 'm') {
                e.preventDefault();
                window.location.href = generateAlternativeGenderUrl(hashArray);
              }
            }}
          >
            <div className="d-flex align-items-center flex-column box">
              <div className="d-flex align-items-center">
                <div className="boy-radio circle-bg circle-bg-green ml-2">
                  <BoyIcon color={formData.gender === 'm' ? '#fff' : '#176c5a'} />
                </div>
                <span>{ageInMonths < 240 || ageInMonths === false ? 'Boys' : 'Men'}</span>
              </div>
              <div className="bottom-line bottom-line-green" />
            </div>
          </a>
        </label>
      </div>

      {/* Female Option */}
      <div className="d-flex flex-column align-items-center w-100">
        <label
          className={`main-checkbox m-auto w-100 ${formData.gender === 'f' ? 'checked' : ''}`}
          style={{ cursor: 'pointer' }}
        >
          <input
            type="radio"
            name="gender"
            value="f"
            checked={formData.gender === 'f'}
            onChange={onChange}
            // className="d-none"
          />
          <a
            href={generateAlternativeGenderUrl(hashArray)}
            style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
            onClick={(e) => {
              if (!isOnChange && formData.gender !== 'f') {
                e.preventDefault();
                window.location.href = generateAlternativeGenderUrl(hashArray);
              }
            }}
          >
            <div className="d-flex align-items-center flex-column box">
              <div className="d-flex align-items-center">
                <div className="boy-radio circle-bg circle-bg-green ml-2">
                  <GirlIcon color={formData.gender === 'f' ? '#fff' : '#176c5a'} />
                </div>
                <span>{ageInMonths < 240 || ageInMonths === false ? 'Girls' : 'Women'}</span>
              </div>
              <div className="bottom-line bottom-line-green" />
            </div>
          </a>
        </label>
      </div>
    </div>
  );
};

export default GenderSelect;
